import {BaseModel} from '../base/BaseModel';
import {RiskUtils} from '../../utils/RiskUtils';

/**
 * @class CropSeasonStatusModel
 * @extends BaseModel
 *
 * @property {object} attributes
 */
export class CropSeasonStatusModel extends BaseModel {

    initialize () {

        this.microservice = 'timing';
        this.resource = 'crop-season-status';
    }

    get idAttribute () {

        return 'uuid';
    }

    get defaults () {

        return {
            status: CropSeasonStatusModel.state.NO_INFORMATION,
            type: undefined,
            cropSeasonUuid: undefined,
            startDate: undefined,
            endDate: undefined,
            calculationDate: undefined
        };
    }

    parse (response) {

        response.startDate = BaseModel.parseDate(response.startDate);
        response.endDate = BaseModel.parseDate(response.endDate);
        response.calculationDate = BaseModel.parseDate(response.calculationDate);

        return response;
    }

    static get state () {

        return {
            HIGH: 'HIGH',
            MEDIUM: 'MEDIUM',
            LOW: 'LOW',
            INACTIVE: 'INACTIVE',
            NO_INFORMATION: 'NO_INFORMATION',
            PROTECTED: 'PROTECTED',
            DISABLED: 'DISABLED'
        };
    }

    static get type () {

        return {
            LODGING: RiskUtils.TYPES.LODGING,
            DISEASE: RiskUtils.TYPES.DISEASE,
            INSECT: RiskUtils.TYPES.INSECT,
            ABIOTIC: RiskUtils.TYPES.ABIOTIC
        };
    }
}


// WEBPACK FOOTER //
// ./shared/model/timing/CropSeasonStatusModel.js